import React from 'react';
import PropTypes from 'prop-types';
import { PlusCircleIcon } from '@glu/icons-react';

// components
import classnames from 'classnames';
import ThemedLink from '../../../themedLink/ThemedLink';

// utils
import AppPropTypes from '../../../../proptypes/AppPropTypes';

// eslint-disable-next-line import/prefer-default-export
export const HeaderContent = ({ classes, locale, onAddMap }) => {
  HeaderContent.propTypes = {
    classes: AppPropTypes.jssClasses.isRequired,
    locale: AppPropTypes.locale.isRequired,
    onAddMap: PropTypes.func.isRequired
  };
  return (
    <div className={classes.subHeading}>
      <ThemedLink
        className={classnames(classes.button, classes.addMapLink)}
        data-qa="plus-circle-icon"
        onClick={onAddMap}
      >
        <PlusCircleIcon />
        {locale['payments.manageImportMaps.addMap']}
      </ThemedLink>
    </div>
  );
};
